/* LG · Recomendador de presentes · v04 · 4 nov 2026 · Pipeline 8.2
   v04: nas peças com cor, mostra quantas cores há disponíveis e, quando há peças Cores nas sugestões,
   um bloco com ligação ao jogo das Cores (textos e ligação na secção). v03: «Unissexo». v02: «Unisex» e «Indiferente».
   Usado por sections/lg-recomendador.liquid. Abre-se com qualquer ligação para #recomendador
   (ou #recomendador=respostas, que abre logo o resultado e serve para partilhar).
   Peças: /collections/all/products.json (só as peças publicadas na loja online).
   Regras fixas: peça disponível, sem a etiqueta «Não recomendar», dentro do orçamento, do tipo
   escolhido, com a etiqueta «Para Ele» quando é para ele e, nos anéis sem tamanho conhecido,
   só os de aro ajustável. Pontos: estilo 3, metal 2, «Favorita» 1. Empate: o preço mais baixo.
   Se houver menos de 3 peças no orçamento, junta as das faixas ao lado, mas as do orçamento vêm primeiro.
   As respostas sem peças ficam desligadas. As etiquetas comparam-se sem maiúsculas nem acentos. */
(function () {
  'use strict';

  var TXT = {
    pt: {
      passo: 'Pergunta {n} de {t}', voltar: 'Voltar', fechar: 'Fechar',
      carregar: 'A carregar as peças…', erro: 'Não conseguimos carregar as peças agora.', erroLink: 'Ver todas as peças',
      semPecas: 'Sem peças agora',
      quem: { ela: ['Para ela', 'Brincos, colares, anéis e mais'], ele: ['Para ele', 'Alianças e botões de punho'], todos: ['Unissexo', 'Mostramos todas as peças'] },
      metal: { prata: ['Prateado', 'Prata'], dourado: ['Dourado', 'Prata dourada e ouro'], qualquer: ['Indiferente', 'Ou ainda não sei'] },
      peca: { brincos: 'Brincos', colar: 'Colar ou pendente', anel: 'Anel', pulseira: 'Pulseira', outro: 'Alfinete ou botões de punho', surpresa: 'Surpreendam-me' },
      tamanho: { sim: ['Sei o tamanho', 'Escolhe-o na página da peça'], nao: ['Não sei', 'Mostramos os anéis de aro ajustável'] },
      chip: { ajustavel: 'Aro ajustável', favorita: 'Escolha da equipa', encomenda: 'Por encomenda', cores1: '1 cor disponível', cores: '{n} cores disponíveis' },
      resumo: 'As suas escolhas', mudar: 'Mudar: ',
      verMais: 'Ver mais peças nesta faixa de preço', recomecar: 'Recomeçar',
      ajuda: 'Prefere escolher com a nossa ajuda?', ajudaBotao: 'Falar por WhatsApp',
      waMsg: 'Olá! Procuro um presente: {r}. Podem ajudar-me a escolher?',
      nenhuma: 'Não encontrámos peças com estas escolhas. Experimente outro orçamento ou outro tipo de peça.',
      alargado: 'Havia poucas peças neste orçamento: juntámos as das faixas ao lado.',
      proximas: 'Poucas peças combinam com tudo o que escolheu: juntámos as mais próximas.',
      novo: ' (abre num novo separador)', moeda: 'pt-PT'
    },
    en: {
      passo: 'Question {n} of {t}', voltar: 'Back', fechar: 'Close',
      carregar: 'Loading the pieces…', erro: "We couldn't load the pieces right now.", erroLink: 'See all pieces',
      semPecas: 'None right now',
      quem: { ela: ['For her', 'Earrings, necklaces, rings and more'], ele: ['For him', 'Wedding bands and cufflinks'], todos: ['Unisex', 'We show every piece'] },
      metal: { prata: ['Silver', 'Silver'], dourado: ['Gold-toned', 'Gilded silver and gold'], qualquer: ['No preference', "Or I'm not sure"] },
      peca: { brincos: 'Earrings', colar: 'Necklace or pendant', anel: 'Ring', pulseira: 'Bracelet', outro: 'Brooch or cufflinks', surpresa: 'Surprise me' },
      tamanho: { sim: ['I know the size', 'Choose it on the piece page'], nao: ["I don't know", 'We show the adjustable rings'] },
      chip: { ajustavel: 'Adjustable', favorita: 'Team pick', encomenda: 'Made to order', cores1: '1 colour available', cores: '{n} colours available' },
      resumo: 'Your choices', mudar: 'Change: ',
      verMais: 'See more pieces in this price range', recomecar: 'Start again',
      ajuda: 'Would you like our help to choose?', ajudaBotao: 'Message us on WhatsApp',
      waMsg: "Hello! I'm looking for a gift: {r}. Could you help me choose?",
      nenhuma: "We couldn't find pieces with these choices. Try another budget or another type of piece.",
      alargado: 'There were few pieces in this budget, so we added the neighbouring price ranges.',
      proximas: 'Few pieces match everything you chose, so we added the closest ones.',
      novo: ' (opens in a new tab)', moeda: 'en-GB'
    }
  };

  var PECAS = {
    brincos: ['Brincos'], colar: ['Colares', 'Pendentes'], anel: ['Anéis', 'Alianças'],
    pulseira: ['Pulseiras'], outro: ['Alfinetes', 'Botões de Punho'], surpresa: []
  };
  var METAIS = { prata: ['Prata', 'Ouro e Prata'], dourado: ['Prata Dourada', 'Ouro', 'Ouro e Prata'], qualquer: [] };
  var SO_ELE = ['Botões de Punho'];
  var PASSOS = ['quem', 'estilo', 'metal', 'peca', 'tamanho', 'orcamento'];

  var IC = 'viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
  var ICONES = {
    brincos: '<svg ' + IC + '><path d="M13 7a3 3 0 0 1 6 0v2"/><circle cx="19" cy="11" r="2"/><path d="M19 13c-3.5 3.5-4.5 6.5-4.5 8.5a4.5 4.5 0 0 0 9 0c0-2-1-5-4.5-8.5z"/></svg>',
    colar: '<svg ' + IC + '><path d="M6 6c1 8 5 12 10 12s9-4 10-12"/><path d="m16 18 0 2"/><path d="M16 20c-2 0-3.5 1.6-3.5 3.6S14 27 16 27s3.5-1.4 3.5-3.4S18 20 16 20z"/></svg>',
    anel: '<svg ' + IC + '><circle cx="16" cy="19" r="8"/><circle cx="16" cy="19" r="5.5"/><path d="m13 8 1.4-3h3.2L19 8l-3 3z"/></svg>',
    pulseira: '<svg ' + IC + '><ellipse cx="16" cy="16" rx="11" ry="7"/><ellipse cx="16" cy="16" rx="8" ry="4.5"/></svg>',
    outro: '<svg ' + IC + '><circle cx="11" cy="21" r="5"/><path d="M14.5 17.5 26 6"/><path d="M22 6h4v4"/></svg>',
    surpresa: '<svg ' + IC + '><path d="M16 4v6M16 22v6M4 16h6M22 16h6"/><path d="m8 8 3 3M21 21l3 3M24 8l-3 3M11 21l-3 3"/></svg>',
    sim: '<svg ' + IC + '><path d="M4 22 22 4l6 6-18 18z"/><path d="m9 17 2 2M12 14l3 3M15 11l2 2M18 8l3 3"/></svg>',
    nao: '<svg ' + IC + '><circle cx="16" cy="16" r="11"/><path d="M13 12.5a3 3 0 1 1 4.2 2.8c-.8.4-1.2 1-1.2 1.9V18"/><path d="M16 22h.01"/></svg>',
    fechar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    seta: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 11.5a8 8 0 0 1-11.7 7.1L4 20l1.4-4.1A8 8 0 1 1 20 11.5z"/></svg>'
  };

  function norm(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
  function lista(v) {
    var a = Array.isArray(v) ? v : String(v || '').split(',');
    return a.map(norm).filter(Boolean);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tem(p, etiquetas) {
    for (var i = 0; i < etiquetas.length; i++) { if (p.tags.indexOf(etiquetas[i]) > -1) return true; }
    return false;
  }
  function raizCom(raiz, caminho) {
    var r = raiz && raiz !== '/' ? raiz.replace(/\/$/, '') : '';
    return r + caminho;
  }

  function Rec(el) {
    var cfgEl = el.querySelector('[data-rec-config]');
    this.el = el;
    this.cfg = JSON.parse(cfgEl.textContent);
    this.t = TXT[this.cfg.lang] || TXT.pt;
    this.dialogo = el.querySelector('dialog');
    this.corpo = el.querySelector('[data-rec-corpo]');
    this.progresso = el.querySelector('[data-rec-progresso]');
    this.contador = el.querySelector('[data-rec-contador]');
    this.voltarBtn = el.querySelector('[data-rec-voltar]');
    this.et = {
      favorita: lista(this.cfg.etiquetas.favorita), excluir: lista(this.cfg.etiquetas.excluir),
      ajustavel: lista(this.cfg.etiquetas.ajustavel), ele: lista(this.cfg.etiquetas.ele)
    };
    this.pecasTags = {};
    for (var k in PECAS) { this.pecasTags[k] = lista(PECAS[k]); }
    this.metaisTags = {};
    for (var m in METAIS) { this.metaisTags[m] = lista(METAIS[m]); }
    this.soEle = lista(SO_ELE);
    this.estilos = (this.cfg.estilos || []).map(function (e) { e.tags = lista(e.etiquetas); return e; });
    this.orcs = this.cfg.orcamentos || [];
    this.r = {};
    this.passo = 0;
    this.produtos = null;
    this.ligar();
  }

  Rec.prototype.ligar = function () {
    var self = this;
    this.el.querySelector('[data-rec-fechar]').addEventListener('click', function () { self.fechar(); });
    this.voltarBtn.addEventListener('click', function () { self.voltar(); });
    this.dialogo.addEventListener('close', function () {
      document.documentElement.classList.remove('lg-rec-aberto');
      if (location.hash.indexOf('#recomendador') === 0 && history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    });
    this.dialogo.addEventListener('click', function (e) { if (e.target === self.dialogo) self.fechar(); });
    this.corpo.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rec-op]');
      if (b && !b.disabled) { self.responder(b.getAttribute('data-rec-passo'), b.getAttribute('data-rec-op')); return; }
      var ir = e.target.closest('[data-rec-ir]');
      if (ir) { self.irPara(ir.getAttribute('data-rec-ir')); return; }
      if (e.target.closest('[data-rec-recomecar]')) { self.r = {}; self.irPara('quem'); return; }
      if (e.target.closest('[data-rec-peca]')) { self.marcarOrigem(); }
    });
  };

  Rec.prototype.abrir = function (hash) {
    if (!this.dialogo.open) {
      if (typeof this.dialogo.showModal === 'function') { this.dialogo.showModal(); } else { this.dialogo.setAttribute('open', ''); }
      document.documentElement.classList.add('lg-rec-aberto');
    }
    var estado = (hash || '').split('=')[1];
    if (estado && this.lerEstado(estado)) { this.mostrar('resultado'); } else { this.r = {}; this.mostrar('quem'); }
    this.carregar();
  };

  Rec.prototype.fechar = function () {
    if (typeof this.dialogo.close === 'function') { this.dialogo.close(); } else { this.dialogo.removeAttribute('open'); }
  };

  Rec.prototype.carregar = function () {
    var self = this;
    if (this.produtos || this.aCarregar) return;
    if (this.cfg.dados) { this.receber(this.cfg.dados); return; }
    this.aCarregar = true;
    var todos = [];
    var pagina = function (n) {
      var sep = self.cfg.produtos.indexOf('?') > -1 ? '&' : '?';
      return fetch(self.cfg.produtos + sep + 'page=' + n, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (j) {
          todos = todos.concat(j.products || []);
          if ((j.products || []).length === 250 && n < 4) return pagina(n + 1);
          return null;
        });
    };
    pagina(1).then(function () { self.receber({ products: todos }); })
      .catch(function () { self.erro = true; self.aCarregar = false; self.mostrar(self.atual || 'quem'); });
  };

  Rec.prototype.receber = function (j) {
    var self = this;
    this.produtos = (j.products || []).map(function (p) { return self.preparar(p); });
    this.aCarregar = false;
    this.mostrar(this.atual || 'quem');
  };

  // Quantas cores diferentes há disponíveis (opção «Cor»/«Color»/«Colour»). 0 se a peça não tem cores.
  function contarCores(disp, opcoes) {
    var i = -1;
    ['cor', 'color', 'colour'].forEach(function (n) { if (i < 0) i = opcoes.indexOf(n); });
    if (i < 0) return 0;
    var vistos = {}, n = 0;
    disp.forEach(function (v) {
      var val = v['option' + (i + 1)];
      var k = val != null ? String(val) : (v.title != null ? String(v.title) : String(n));
      if (!vistos[k]) { vistos[k] = true; n++; }
    });
    return n;
  }

  Rec.prototype.preparar = function (p) {
    var disp = (p.variants || []).filter(function (v) { return v.available; });
    var precos = disp.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
    var opcoes = (p.options || []).map(function (o) { return norm(o && o.name != null ? o.name : o); });
    var img = p.images && p.images[0] ? (p.images[0].src || '') : '';
    return {
      handle: p.handle,
      nome: String(p.title || '').split('|')[0].trim(),
      tags: lista(p.tags),
      disponivel: disp.length > 0,
      preco: precos.length ? Math.min.apply(null, precos) : null,
      comTamanho: opcoes.indexOf('tamanho') > -1 || opcoes.indexOf('size') > -1,
      nCores: contarCores(disp, opcoes),
      img: img
    };
  };

  // Regras fixas (ver o topo do ficheiro). «orc» é a faixa de orçamento, ou nada para não filtrar pelo preço.
  Rec.prototype.passa = function (p, r, orc) {
    if (!p.disponivel || p.preco === null) return false;
    if (tem(p, this.et.excluir)) return false;
    if (r.quem === 'ele' && !tem(p, this.et.ele)) return false;
    if (r.quem === 'ela' && tem(p, this.soEle) && r.peca !== 'outro') return false;
    if (r.peca && r.peca !== 'surpresa' && !tem(p, this.pecasTags[r.peca])) return false;
    if (r.peca === 'anel' && r.tamanho === 'nao' && !tem(p, this.et.ajustavel)) return false;
    if (orc && (p.preco < (orc.min || 0) || (orc.max != null && p.preco > orc.max))) return false;
    return true;
  };

  Rec.prototype.estilo = function (id) {
    for (var i = 0; i < this.estilos.length; i++) { if (this.estilos[i].id === id) return this.estilos[i]; }
    return null;
  };
  Rec.prototype.orc = function (id) {
    for (var i = 0; i < this.orcs.length; i++) { if (this.orcs[i].id === id) return this.orcs[i]; }
    return null;
  };

  // Quantas peças ficam se esta resposta for escolhida (com as respostas anteriores).
  Rec.prototype.contar = function (passo, valor) {
    if (!this.produtos) return 1;
    var r = {}, self = this, i;
    for (i = 0; i < PASSOS.length && PASSOS[i] !== passo; i++) { r[PASSOS[i]] = this.r[PASSOS[i]]; }
    r[passo] = valor;
    var orc = passo === 'orcamento' ? this.orc(valor) : null;
    var est = passo === 'estilo' ? this.estilo(valor) : null;
    var met = passo === 'metal' ? this.metaisTags[valor] : null;
    var n = 0;
    this.produtos.forEach(function (p) {
      if (!self.passa(p, r, orc)) return;
      if (est && !tem(p, est.tags)) return;
      if (met && met.length && !tem(p, met)) return;
      n++;
    });
    return n;
  };

  Rec.prototype.sequencia = function () {
    return PASSOS.filter(function (p) { return p !== 'tamanho' || this.r.peca === 'anel'; }, this);
  };

  Rec.prototype.responder = function (passo, valor) {
    var bs = this.corpo.querySelectorAll('[data-rec-passo="' + passo + '"]');
    for (var j = 0; j < bs.length; j++) { bs[j].setAttribute('aria-pressed', bs[j].getAttribute('data-rec-op') === valor ? 'true' : 'false'); }
    this.r[passo] = valor;
    if (passo === 'peca' && valor !== 'anel') delete this.r.tamanho;
    var seq = this.sequencia();
    var i = seq.indexOf(passo);
    var seguinte = seq[i + 1] || 'resultado';
    var self = this;
    window.setTimeout(function () { self.mostrar(seguinte); }, 140);
  };

  Rec.prototype.irPara = function (passo) { this.mostrar(passo); };

  Rec.prototype.voltar = function () {
    var seq = this.sequencia();
    if (this.atual === 'resultado') { this.mostrar(seq[seq.length - 1]); return; }
    var i = seq.indexOf(this.atual);
    if (i > 0) this.mostrar(seq[i - 1]);
  };

  Rec.prototype.mostrar = function (passo) {
    this.atual = passo;
    var t = this.t, c = this.cfg.textos, html = '';
    var visiveis = ['quem', 'estilo', 'metal', 'peca', 'orcamento'];
    var n = passo === 'tamanho' ? 4 : visiveis.indexOf(passo) + 1;
    var marcas = this.progresso.querySelectorAll('span');
    for (var i = 0; i < marcas.length; i++) {
      marcas[i].className = passo === 'resultado' || i < n - 1 ? 'is-feito' : (i === n - 1 ? 'is-atual' : '');
    }
    this.contador.textContent = passo === 'resultado' ? '' : t.passo.replace('{n}', n).replace('{t}', 5);
    this.voltarBtn.hidden = passo === 'quem';
    this.el.querySelector('.lg-rec__caixa').setAttribute('data-passo', passo);

    if (this.erro) {
      html = '<div class="lg-rec__aviso"><p>' + esc(t.erro) + '</p><p><a href="' + esc(this.cfg.colecao) + '">' + esc(t.erroLink) + '</a></p></div>';
    } else if (passo === 'resultado') {
      html = this.htmlResultado();
    } else {
      html = this.htmlPergunta(passo, c);
    }
    this.corpo.innerHTML = html;
    var h = this.corpo.querySelector('h2');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    this.corpo.scrollTop = 0;
    if (passo === 'resultado') this.guardarEstado();
  };

  Rec.prototype.op = function (passo, valor, rotulo, sub, extra, classe) {
    var n = this.contar(passo, valor);
    var off = n === 0 && valor !== 'surpresa' && valor !== 'todos' && valor !== 'qualquer';
    var on = this.r[passo] === valor;
    return '<button type="button" class="lg-rec__op' + (classe ? ' ' + classe : '') + '" data-rec-passo="' + passo + '" data-rec-op="' + esc(valor) + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '"' + (off ? ' disabled' : '') + '>' + (extra || '') +
      '<span class="lg-rec__op-rotulo">' + esc(rotulo) + '</span>' +
      '<span class="lg-rec__op-sub">' + esc(off ? this.t.semPecas : (sub || '')) + '</span></button>';
  };

  Rec.prototype.htmlPergunta = function (passo, c) {
    var t = this.t, self = this, ops = '', cls = 'lg-rec__ops';
    var titulo = c['q_' + passo] || '';
    var intro = passo === 'quem' && c.intro ? '<p class="lg-rec__intro">' + esc(c.intro) + '</p>' : '';
    if (passo === 'quem') {
      cls += ' lg-rec__ops--3';
      ['ela', 'ele', 'todos'].forEach(function (v) { ops += self.op('quem', v, t.quem[v][0], t.quem[v][1]); });
    } else if (passo === 'estilo') {
      cls += ' lg-rec__ops--img';
      this.estilos.forEach(function (e) {
        var img = '<span class="lg-rec__op-img">' + (e.imagem ? '<img src="' + esc(e.imagem) + '" alt="" loading="lazy" width="300" height="375" onerror="this.remove()">' : '') + '</span>';
        ops += self.op('estilo', e.id, e.rotulo, e.texto, img, 'lg-rec__op--img');
      });
    } else if (passo === 'metal') {
      cls += ' lg-rec__ops--3';
      ['prata', 'dourado', 'qualquer'].forEach(function (v) {
        ops += self.op('metal', v, t.metal[v][0], t.metal[v][1], '<span class="lg-rec__metal lg-rec__metal--' + v + '" aria-hidden="true"></span>', 'lg-rec__op--metal');
      });
    } else if (passo === 'peca') {
      cls += ' lg-rec__ops--3';
      ['brincos', 'colar', 'anel', 'pulseira', 'outro', 'surpresa'].forEach(function (v) {
        ops += self.op('peca', v, t.peca[v], '', '<span class="lg-rec__op-ic">' + ICONES[v] + '</span>', 'lg-rec__op--ic');
      });
    } else if (passo === 'tamanho') {
      cls += ' lg-rec__ops--2';
      ['sim', 'nao'].forEach(function (v) {
        ops += self.op('tamanho', v, t.tamanho[v][0], t.tamanho[v][1], '<span class="lg-rec__op-ic">' + ICONES[v] + '</span>', 'lg-rec__op--ic');
      });
    } else if (passo === 'orcamento') {
      cls += ' lg-rec__ops--orc';
      this.orcs.forEach(function (o) { ops += self.op('orcamento', o.id, o.rotulo, o.texto, '', 'lg-rec__op--orc'); });
    }
    var carregar = !this.produtos ? '<p class="lg-rec__carregar" role="status">' + esc(t.carregar) + '</p>' : '';
    return intro + '<h2 class="lg-rec__h">' + esc(titulo) + '</h2>' + carregar +
      '<div class="' + cls + '" role="group" aria-label="' + esc(titulo) + '">' + ops + '</div>';
  };

  Rec.prototype.rotulos = function () {
    var t = this.t, r = this.r, out = [];
    var est = this.estilo(r.estilo), orc = this.orc(r.orcamento);
    if (r.quem) out.push(['quem', t.quem[r.quem][0]]);
    if (est) out.push(['estilo', est.rotulo]);
    if (r.metal) out.push(['metal', t.metal[r.metal][0]]);
    if (r.peca) out.push(['peca', t.peca[r.peca] + (r.peca === 'anel' && r.tamanho === 'nao' ? ' · ' + t.chip.ajustavel : '')]);
    if (orc) out.push(['orcamento', orc.rotulo]);
    return out;
  };

  Rec.prototype.calcular = function () {
    var self = this, r = this.r, orc = this.orc(r.orcamento), nota = '';
    var base = (this.produtos || []).filter(function (p) { return self.passa(p, r, orc); });
    if (base.length < 3 && orc) {
      var i = this.orcs.indexOf(orc);
      var de = this.orcs[Math.max(0, i - 1)], ate = this.orcs[Math.min(this.orcs.length - 1, i + 1)];
      var largo = { min: de.min || 0, max: ate.max };
      var mais = (this.produtos || []).filter(function (p) { return self.passa(p, r, largo); });
      if (mais.length > base.length) { base = mais; nota = this.t.alargado; }
    }
    var est = this.estilo(r.estilo), met = this.metaisTags[r.metal] || [];
    var lista2 = base.map(function (p) {
      var e = est && tem(p, est.tags), m = met.length && tem(p, met), f = tem(p, self.et.favorita);
      var d = !orc || self.passa(p, r, orc);
      return { p: p, e: !!e, m: !!m, f: f, s: (d ? 10 : 0) + (e ? 3 : 0) + (m ? 2 : 0) + (f ? 1 : 0) };
    });
    lista2.sort(function (a, b) { return b.s - a.s || a.p.preco - b.p.preco; });
    // Variedade: no máximo 2 peças com o mesmo nome (ex.: «Anel CORES»); se faltarem, completa com as restantes.
    var vistos = {}, fim = [], resto = [], n = this.cfg.n || 6;
    lista2.forEach(function (x) {
      var k = norm(x.p.nome);
      vistos[k] = (vistos[k] || 0) + 1;
      if (vistos[k] <= 2 && fim.length < n) { fim.push(x); } else { resto.push(x); }
    });
    for (var j = 0; j < resto.length && fim.length < n; j++) fim.push(resto[j]);
    fim.sort(function (a, b) { return b.s - a.s || a.p.preco - b.p.preco; });
    var completas = fim.filter(function (x) { return (!est || x.e) && (!met.length || x.m); }).length;
    if (!nota && fim.length && completas < Math.min(3, fim.length)) nota = this.t.proximas;
    return { itens: fim, nota: nota };
  };

  Rec.prototype.preco = function (v) {
    try { return new Intl.NumberFormat(this.t.moeda, { style: 'currency', currency: 'EUR' }).format(v); } catch (e) { return v.toFixed(2) + ' €'; }
  };

  Rec.prototype.htmlResultado = function () {
    var t = this.t, c = this.cfg.textos, self = this;
    var chips = this.rotulos().map(function (x) {
      return '<button type="button" class="lg-rec__escolha" data-rec-ir="' + x[0] + '" aria-label="' + esc(t.mudar + x[1]) + '">' + esc(x[1]) + '</button>';
    }).join('');
    var topo = '<h2 class="lg-rec__h">' + esc(c.res_titulo || '') + '</h2>' +
      '<div class="lg-rec__escolhas"><span class="lg-rec__escolhas-r">' + esc(t.resumo) + '</span>' + chips + '</div>';
    if (!this.produtos) return topo + '<p class="lg-rec__carregar" role="status">' + esc(t.carregar) + '</p>';
    var res = this.calcular();
    var est = this.estilo(this.r.estilo);
    var cards = res.itens.map(function (x) {
      var p = x.p, ch = [];
      if (x.e && est) ch.push(esc(est.rotulo));
      if (x.m) ch.push(esc(t.metal[self.r.metal][0]));
      if (p.comTamanho === false && tem(p, self.et.ajustavel) && tem(p, self.pecasTags.anel)) ch.push(esc(t.chip.ajustavel));
      if (p.nCores > 0) ch.push(esc(p.nCores === 1 ? t.chip.cores1 : t.chip.cores.replace('{n}', p.nCores)));
      if (x.f) ch.push(esc(t.chip.favorita));
      if (tem(p, lista(['Por encomenda']))) ch.push('<b>' + esc(t.chip.encomenda) + '</b>');
      var src = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
      return '<li><a class="lg-rec__peca" data-rec-peca href="' + esc(raizCom(self.cfg.raiz, '/products/' + p.handle)) + '">' +
        '<span class="lg-rec__peca-img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="500" height="500" onerror="this.remove()">' : '') + '</span>' +
        '<span class="lg-rec__peca-nome">' + esc(p.nome) + '</span>' +
        '<span class="lg-rec__peca-preco">' + esc(self.preco(p.preco)) + '</span>' +
        (ch.length ? '<span class="lg-rec__chips">' + ch.map(function (s) { return '<span>' + s + '</span>'; }).join('') + '</span>' : '') +
        '</a></li>';
    }).join('');
    var corpo = res.itens.length
      ? (res.nota ? '<p class="lg-rec__nota">' + esc(res.nota) + '</p>' : '') + '<ul class="lg-rec__pecas" role="list">' + cards + '</ul>'
      : '<p class="lg-rec__nota">' + esc(t.nenhuma) + '</p>';
    corpo += this.htmlCores(res.itens);
    var orc = this.orc(this.r.orcamento);
    var mais = this.cfg.colecao + '?filter.v.availability=1' + (orc ? '&filter.v.price.gte=' + (orc.min || 0) + (orc.max != null ? '&filter.v.price.lte=' + orc.max : '') : '') + '&sort_by=price-ascending';
    var resumo = this.rotulos().map(function (x) { return x[1]; }).join(', ').toLowerCase();
    var wa = this.cfg.whatsapp ? '<a class="lg-rec__botao lg-rec__botao--wa" href="https://wa.me/' + esc(this.cfg.whatsapp) + '?text=' +
      encodeURIComponent(t.waMsg.replace('{r}', resumo)) + '" target="_blank" rel="noopener">' + ICONES.wa + '<span>' + esc(t.ajudaBotao) + '</span><span class="lg-rec__oculto">' + esc(t.novo) + '</span></a>' : '';
    var acoes = '<div class="lg-rec__acoes"><a class="lg-rec__botao" href="' + esc(mais) + '">' + esc(t.verMais) + '</a>' +
      '<button type="button" class="lg-rec__botao lg-rec__botao--texto" data-rec-recomecar>' + esc(t.recomecar) + '</button></div>' +
      (wa ? '<div class="lg-rec__ajuda"><p>' + esc(t.ajuda) + '</p>' + wa + '</div>' : '');
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lg_recomendador_resultado', { respostas: this.r, pecas: res.itens.length }); } catch (e) {}
    return topo + corpo + acoes;
  };

  // Bloco com ligação ao jogo das Cores: só aparece se houver peças com a etiqueta das Cores nas sugestões.
  Rec.prototype.htmlCores = function (itens) {
    var c = this.cfg.cores;
    if (!c || !c.link || !c.botao) return '';
    var et = lista(c.etiqueta || 'Cores');
    var ha = itens.some(function (x) { return tem(x.p, et); });
    if (!ha) return '';
    var paleta = ['#d4102d', '#ff7466', '#ecc32e', '#a2d39d', '#057aae', '#330072'].map(function (h) {
      return '<span style="background:' + h + '"></span>';
    }).join('');
    var href = c.link.charAt(0) === '/' && c.link.charAt(1) !== '/' ? raizCom(this.cfg.raiz, c.link) : c.link;
    return '<div class="lg-rec__cores"><span class="lg-rec__cores-paleta" aria-hidden="true">' + paleta + '</span>' +
      '<div class="lg-rec__cores-texto">' + (c.titulo ? '<p class="lg-rec__cores-titulo">' + esc(c.titulo) + '</p>' : '') +
      (c.texto ? '<p>' + esc(c.texto) + '</p>' : '') + '</div>' +
      '<a class="lg-rec__botao" href="' + esc(href) + '">' + esc(c.botao) + '</a></div>';
  };

  Rec.prototype.guardarEstado = function () {
    var r = this.r;
    var s = [r.quem, r.estilo, r.metal, r.peca, r.tamanho || '-', r.orcamento].join('.');
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + '#recomendador=' + s);
  };

  Rec.prototype.lerEstado = function (s) {
    var a = decodeURIComponent(s).split('.');
    if (a.length < 6) return false;
    var r = { quem: a[0], estilo: a[1], metal: a[2], peca: a[3], orcamento: a[5] };
    if (a[3] === 'anel' && a[4] !== '-') r.tamanho = a[4];
    if (!TXT.pt.quem[r.quem] || !this.estilo(r.estilo) || !METAIS[r.metal] || !PECAS[r.peca] || !this.orc(r.orcamento)) return false;
    this.r = r;
    return true;
  };

  // Na encomenda fica «Origem: Recomendador de presentes», para medir as vendas que o recomendador traz.
  Rec.prototype.marcarOrigem = function () {
    try { if (sessionStorage.getItem('lgRecOrigem')) return; sessionStorage.setItem('lgRecOrigem', '1'); } catch (e) {}
    try {
      fetch(raizCom(this.cfg.raiz, '/cart/update.js'), {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Origem: 'Recomendador de presentes' } })
      }).catch(function () {});
    } catch (e) {}
  };

  function atual() {
    var el = document.querySelector('[data-lg-rec]');
    if (!el) return null;
    if (!el.lgRec) el.lgRec = new Rec(el);
    return el.lgRec;
  }
  function iniciar() {
    var rec = atual();
    if (rec && location.hash.indexOf('#recomendador') === 0) rec.abrir(location.hash);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#recomendador"]');
    if (!a || a.closest('[data-lg-rec] dialog')) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname) return;
    var rec = atual();
    if (!rec) return;
    e.preventDefault();
    rec.abrir(url.hash);
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
  document.addEventListener('shopify:section:load', function () { atual(); });
})();
